export const patchSuccessToast = {
  title: '已成功修改 $t(tracker:displayKind, {"context": "{{context}}" })',
};
